var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 23.125V30.9999M21.3333 23.125H17.4219C16.9241 23.125 16.6754 23.125 16.4852 23.2203C16.318 23.3042 16.1821 23.438 16.0969 23.6026C16 23.7898 16 24.035 16 24.525V30.9999H21.3333M21.3333 23.125V18.4001C21.3333 17.91 21.3333 17.6648 21.4302 17.4777C21.5154 17.313 21.6513 17.1793 21.8186 17.0954C22.0087 17 22.2574 17 22.7552 17H25.2441C25.7419 17 25.9914 17 26.1815 17.0954C26.3488 17.1793 26.4842 17.313 26.5694 17.4777C26.6663 17.6648 26.6667 17.91 26.6667 18.4001V20.5M21.3333 30.9999H26.6667M26.6667 30.9999L32 31V21.9001C32 21.41 31.9997 21.1648 31.9028 20.9776C31.8176 20.813 31.6826 20.6792 31.5154 20.5953C31.3252 20.5 31.0756 20.5 30.5778 20.5H26.6667M26.6667 30.9999V20.5",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.db19c5b80d8c56ea20cbbc5bd3aba367.svg";
export { ForwardRef as ReactComponent };